const isClientSide = () => typeof window !== 'undefined';

const isServerSide = () => !isClientSide();

const getFlag = flagName => (isServerSide() ? process.env : window.CFG)[flagName];

export { isClientSide, isServerSide, getFlag };
